import React from "react";

import Card from "@src/sharedComponents/Card/Card";
import Skeleton from "@src/sharedComponents/Skeleton/Skeleton";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "../HouseholdAccounts.module.css";

interface HouseholdAUMCardProps {
  amount: string;
  isLoading?: boolean;
}

const HouseholdAUMCard = ({
  amount,
  isLoading,
}: HouseholdAUMCardProps): JSX.Element => {
  return (
    <Card
      header={
        <Text variant="body" color="textSubtle">
          Household AUM
        </Text>
      }
    >
      {isLoading ? (
        <Skeleton width="150px" height="32px" className={styles.cardBodyText} />
      ) : (
        <Text className={styles.cardBodyText} variant="title2">
          {amount}
        </Text>
      )}
    </Card>
  );
};

export default HouseholdAUMCard;
